<template>
  <div class="sum-list">
    <ul class="counts-list">
      <li class="item" v-for="(item, index) in list" :key="index">
        <p>{{item.title}}</p>
        <p>{{item.value}}</p>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  components:{},
  props:{
    list: {
      type: Array,
      default: () => [
        {title: '订货单数', value: '1'},
        {title: '订货客户', value: '1'},
        {title: '订货金额', value: '80'},
        {title: '客售价', value: '80'}
      ]
    }
  },
  data(){
    return {
    }
  },
  watch:{},
  computed:{},
  methods:{
    formatMoney(val, idx) {
      if (idx < 2) {
        return val
      } else {
        return '￥' + this.formatPrice(val)
      }
    },
    formatPrice(price) {
      price = Number(price).toFixed(2) + '';
      return price.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    }
  },
  created(){},
  mounted(){}
}
</script>
<style lang="scss" scoped>
.sum-list{
  .counts-list {
    display: flex;
    height: 80px;
    padding: 10px 0;
    .item {
      flex: 1;
      border-right: 1px solid #eaebea;
      text-align: center;
      padding: 5px;
      &:last-child {
        border: none;
      }
      // &:nth-child(4) {
      //   p:last-child {
      //     color: red;
      //   }
      // }
      p {
        line-height: 35px;
      }
      p:last-child {
        font-weight: 700;
      }
    }
  }
}
</style>